<template lang="pug">
  div.event-general
    div.summary
      module-title(title="提要")
      div.summary-content {{summary}}
    event-learning(:eventId="$route.params.id" v-if="hasRule")
    div.general
      .crisis
        crisis-evaluation
        .crisis-bottom
          crisis-quota(:tags="tags")
      context-node
</template>
<script>
import ModuleTitle from '../EventCenter/ModuleTitle'
import ContextNode from './ContextNode'
import CrisisEvaluation from './CrisisEvaluation'
import CrisisQuota from './CrisisQuota'
import EventLearning from './EventLearning'
import client from '../server/server'
import { toThousands } from '../config/config'
export default {
  name: 'EventGeneral',
  components: {
    ModuleTitle,
    ContextNode,
    CrisisEvaluation,
    CrisisQuota,
    EventLearning
  },
  props: {
    event: Object
  },
  computed: {
    hasRule () {
      return this.event.hasRule
    }
  },
  data () {
    return {
      tags: [],
      summary: ''
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      let params = {
        id: this.$route.params.id
      }
      client.getEventOverview(params)
        .then(res => {
          if (res.success) {
            this.summary = `本次事件公关传播效果指数${res.data.interveneScore}，超过系统内${res.data.compareInterveneScore}的事件。事件初期主要在${res.data.lurkMaxPlatform}平台传播，危机传播过程中，网媒平台占比${res.data.wmPro}；微博平台舆论占比${res.data.wbPro}，转评赞总量${toThousands(res.data.interactionNum)}；微信平台传播占比${res.data.wxPro}。`
            this.tags = [[
              {
                name: '传播量',
                value: toThousands(res.data.articleCount)
              },
              {
                name: '持续周期',
                value: res.data.continueTime
              },
              {
                name: '公关回应次数',
                value: toThousands(res.data.interveneCount)
              },
              {
                name: '次生舆情',
                value: toThousands(res.data.secondaryCount)
              }], [
              {
                name: '主流媒体',
                value: toThousands(res.data.importantCount),
                avg: `/${toThousands(res.data.avgImportantCount)}`,
                tooltip: `主流媒体：${toThousands(res.data.importantCount)} 均值：${toThousands(res.data.avgImportantCount)}`
              },
              {
                name: '微博千万粉丝用户',
                value: toThousands(res.data.qwFanCount),
                avg: `/${toThousands(res.data.avgQwFanCount)}`,
                tooltip: `微博千万粉丝用户：${toThousands(res.data.qwFanCount)} 均值：${toThousands(res.data.avgQwFanCount)}`
              },
              {
                name: '微博百万粉丝用户',
                value: toThousands(res.data.bwFanCount),
                avg: `/${toThousands(res.data.avgBwFanCount)}`,
                tooltip: `微博百万粉丝用户：${toThousands(res.data.bwFanCount)} 均值：${toThousands(res.data.avgBwFanCount)}`
              },
              {
                name: '微博十万粉丝用户',
                value: toThousands(res.data.swFanCount),
                avg: `/${toThousands(res.data.avgSwFanCount)}`,
                tooltip: `微博十万粉丝用户：${toThousands(res.data.swFanCount)} 均值：${toThousands(res.data.avgSwFanCount)}`
              }
            ]]
            let gaugeData = {
              crisisLevel: res.data.crisisLevel,
              crisisLevelZh: res.data.crisisLevelZh
            }
            this.$store.dispatch('eventGaugeData', gaugeData)
            let liquidData = {
              interveneLevel: res.data.interveneLevel,
              interveneScore: res.data.interveneScore
            }
            this.$store.dispatch('eventLiquidFillData', liquidData)
          }
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.event-general {
  .summary {
    padding: 14px;
    background-color: #fff;
    border-radius: 4px;
    min-height: 78px;

    .summary-content {
      margin-top: 10px;
      color: #666;
    }
  }

  .general {
    margin-top: 20px;
    display: flex;

    .crisis {
      width: 100%;
      flex: 1;

      .crisis-bottom {
        -webkit-margin-top-collapse: 20px;
        flex: 0 0 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventGeneral/EventGeneral.vue